import React, {
  createContext,
  type FC,
  useContext,
  useEffect,
  useMemo,
} from "react";
import { I18nextProvider } from "react-i18next";

import createTranslationsManager from "./TranslationsManager";
import type { TranslationsManager, TranslationsProviderProps } from "./types";

const TranslationsManagerContext = createContext<TranslationsManager>(null!);

const TranslationsProvider: FC<TranslationsProviderProps> = ({
  children,
  options,
}) => {
  const translationsManager = useMemo(
    () => createTranslationsManager(options),
    [options],
  );

  useEffect(() => {
    return () => translationsManager.clear();
  }, [translationsManager]);

  return (
    <I18nextProvider i18n={translationsManager.getI18next()}>
      <TranslationsManagerContext.Provider value={translationsManager}>
        {children}
      </TranslationsManagerContext.Provider>
    </I18nextProvider>
  );
};

export const useTranslationsManager = () =>
  useContext(TranslationsManagerContext);

export default TranslationsProvider;
